module.exports = __webpack_public_path__ + "static/12-dfa1287bcf00336258a3e55c4df3e289.jpg";